"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareClassServiceStub = void 0;
const faker = __importStar(require("faker"));
class ShareClassServiceStub {
    getShareClasses(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const total = faker.random.number({ min: 2, max: 5 });
            const classes = [];
            for (let i = 0; i < total; i += 1) {
                classes.push({
                    _id: faker.random.alphaNumeric(),
                    companyId,
                    name: faker.random.alphaNumeric(),
                    shareClassCode: faker.random.alphaNumeric(4),
                    pricePerShare: faker.random.number(),
                    effectiveFrom: faker.date.past(),
                });
            }
            return { status: true, message: "", payload: classes };
        });
    }
    getShareholderHoldingForShareClass(companyId, shareholderId, shareClassId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (companyId && shareholderId && shareClassId) {
                return {
                    status: true,
                    message: "",
                    payload: {
                        _id: faker.random.alphaNumeric(),
                        totalQuantity: faker.random.number(),
                        totalAmountPaid: faker.random.number(),
                        totalAmountUnpaid: faker.random.number(),
                    },
                };
            }
            return {
                status: false,
                message: "Invalid request",
                payload: null,
            };
        });
    }
}
exports.ShareClassServiceStub = ShareClassServiceStub;
//# sourceMappingURL=ShareClassServiceStub.js.map